

export class ValidationService {
    static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
        let config = {
            'required': `Required`,
            'invalidCreditCard': 'Is invalid credit card number',
            'invalidEmailAddress': 'Invalid email address',
            'invalidPassword': 'Invalid password. Password must be at least 8 characters long with 1 Small,Capital letter and a number.',
            'invalidUsername': 'Invalid username. Username must be at least 3 characters long.',
            'invalidPhone': 'Invalid Mobile Number. Mobile Number must be at least 10 digit number.',
            'minlength': `Minimum length is ${validatorValue.requiredLength}`,
            'maxlength': `Maximum length is ${validatorValue.requiredLength}`,
            'noSpace': `not valid`,
        };

        return config[validatorName];
    }


    static noSpaceValidator(control) {
        // Visa, MasterCard, American Express, Diners Club, Discover, JCB
        if (control.value.match(/^[^\s]+(\s+[^\s]+)*$/)) {
            return null;
        } else {
            return { 'noSpace': true };
        }
    }

    static creditCardValidator(control) {
        // Visa, MasterCard, American Express, Diners Club, Discover, JCB
        if (control.value.match(/^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/)) {
            return null;
        } else {
            return { 'invalidCreditCard': true };
        }
    }

    static emailValidator(control) {
        // RFC 2822 compliant regex
        if (control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
            return null;
        } else {
            return { 'invalidEmailAddress': true };
        }
    }

    static passwordValidator(control) {
        // {6,100}           - Assert password is between 6 and 100 characters
        // (?=.*[0-9])       - Assert a string has at least one number
        //^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$ -Minimum eight characters, at least one uppercase letter, one lowercase letter and one number
        //^[a-zA-Z0-9!#$%@&\\'*+\/=?^_`{|}~\-\()\[\];:",<>.]{6,100}$ - old
        //if (control.value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,100}$/)) {
        if (control.value.match(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/)) {
                return null;
        } else {
            return { 'invalidPassword': true };
        }
    }

    static phoneValidator(control) {
        // {6,100}           - Assert password is between 6 and 100 characters
        // (?=.*[0-9])       - Assert a string has at least one number
        if (control.value.match(/^(?=.*[0-9])[0-9]{10,10}$/)) {
            return null;
        } else {
            return { 'invalidPhone': true };
        }
    }
    
    static usernameValidator(control){
        if (control.value.match(/^(?=.*[a-zA-Z])[a-zA-Z0-9]{3,50}$/)) {
            return null;
        } else {
            return { 'invalidUsername': true };
        }
    }
}






// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/validation.service.ts